module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.0-218.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.2.0.md
// module id = 662
// module chunks = 331